module.exports = __webpack_public_path__ + "img/vip-pic2.a6d86440.png";